import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  addItem: {
    float: 'right',
  },
  errorRow: {
    background: 'red',
  },
  filterDimensionsContainer: {
    background: theme.palette.white,
    padding: pxToRem(15),
    marginTop: pxToRem(25),
  },
  filterDimensionEditor: {
    marginTop: pxToRem(40),
    width: '100%',
    selectors: {
      '& .ms-DetailsHeader-cellTitle': {
        height: '100% !important',
        alignItems: 'center !important',
      },
      '& .ms-DetailsHeader-cellName': {
        alignItems: 'center !important',
      },
    },
  },
  excludeButton: {
    background: 'transparent',
    width: '100%',
    selectors: {
      '& .ms-Icon': {
        fontSize: pxToRem(18),
      },
    },
  },
  messageHeader: {
    paddingBottom: pxToRem(4),
  },
});
